var _g, _rect, _g2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkSaved({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 173,
    viewBox: "0 0 163 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2091_13883)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 138,
    height: 138,
    rx: 69,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2091_13883)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2091_13883",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 163,
    height: 163
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 163,
    height: 163,
    rx: 29.2767,
    fill: "#FBFBFB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2091_13883)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.126 65.207C108.347 66.4274 108.347 68.406 107.126 69.6264L77.9597 98.7931C76.7394 100.013 74.7607 100.013 73.5403 98.7931L56.8737 82.1264C55.6533 80.906 55.6533 78.9274 56.8737 77.707C58.0941 76.4866 60.0727 76.4866 61.2931 77.707L75.75 92.1639L102.707 65.207C103.927 63.9866 105.906 63.9866 107.126 65.207Z",
    fill: "#555CC1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3715 29.6834C52.4051 23.1073 63.0009 19.0071 74.108 17.7895C85.2151 16.5718 96.4476 18.2791 106.691 22.742L100.292 37.4315C92.6087 34.0844 84.1844 32.8039 75.854 33.7171C67.5237 34.6303 59.5769 37.7055 52.8017 42.6376L43.3715 29.6834Z",
    fill: "#C0C2E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1709 112.815C20.5668 104.593 17.8323 95.4568 17.1622 86.0574C16.4922 76.6579 17.903 67.2264 21.2943 58.4344L36.2438 64.2008C33.7003 70.7948 32.6422 77.8684 33.1447 84.918C33.6473 91.9676 35.6981 98.8196 39.1512 104.986L25.1709 112.815Z",
    fill: "#C0C2E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0922 25.4193C81.0922 20.9947 84.6929 17.3562 89.083 17.9078C96.4208 18.8299 103.564 21.0177 110.189 24.3934C119.202 28.9853 126.999 35.6448 132.944 43.8275C138.889 52.0103 142.813 61.4839 144.395 71.4738C145.559 78.8179 145.432 86.2878 144.041 93.5514C143.209 97.8971 138.636 100.197 134.428 98.8299C130.22 97.4626 127.989 92.9407 128.64 88.5641C129.356 83.7429 129.337 78.8251 128.57 73.9803C127.383 66.4879 124.44 59.3827 119.981 53.2457C115.522 47.1086 109.674 42.1139 102.915 38.6701C98.5446 36.4432 93.8734 34.9055 89.0668 34.0969C84.7035 33.3629 81.0922 29.844 81.0922 25.4193Z",
    fill: "#555CC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.507 90.7914C142.191 106.604 134.049 120.981 121.681 131.102C109.312 141.223 93.608 146.358 77.6491 145.5L78.5099 129.5C90.479 130.144 102.257 126.293 111.533 118.702C120.81 111.111 126.916 100.328 128.654 88.4685L144.507 90.7914Z",
    fill: "#555CC1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1222 61.7398C24.2951 48.8642 32.4371 37.6402 43.3812 29.6764L52.8089 42.6323C44.6009 48.6051 38.4944 57.0232 35.3647 66.6799L20.1222 61.7398Z",
    fill: "#C0C2E3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.561 137.313C86.9925 141.717 83.7638 145.689 79.3408 145.568C72.3249 145.377 65.3695 144.033 58.757 141.575C49.6341 138.183 41.4035 132.758 34.6896 125.711C27.9757 118.664 22.9549 110.181 20.0081 100.905C17.0613 91.6284 16.2659 81.8029 17.6822 72.1734C19.0986 62.5439 22.6894 53.3635 28.1824 45.3286C33.6754 37.2937 40.9263 30.6154 49.3848 25.8003C57.8434 20.9852 67.2875 18.1598 77.0007 17.5385C84.0411 17.0881 91.0888 17.8043 97.8627 19.6408C102.133 20.7985 104.081 25.5322 102.4 29.625C100.719 33.7178 96.0416 35.6008 91.7266 34.6219C87.2483 33.606 82.6339 33.234 78.0236 33.5289C70.7387 33.9949 63.6556 36.1139 57.3117 39.7252C50.9678 43.3366 45.5296 48.3453 41.4099 54.3715C37.2901 60.3976 34.597 67.283 33.5347 74.5051C32.4725 81.7272 33.069 89.0963 35.2791 96.0535C37.4892 103.011 41.2548 109.373 46.2902 114.658C51.3256 119.943 57.4986 124.012 64.3408 126.556C68.6709 128.166 73.197 129.138 77.7782 129.455C82.1924 129.76 86.1295 132.91 86.561 137.313Z",
    fill: "#555CC1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2091_13883",
    x: 3.10922,
    y: 13,
    width: 157.782,
    height: 159.76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.8689
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.94539
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.242263 0 0 0 0 0.261111 0 0 0 0 0.541146 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2091_13883"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2091_13883",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2091_13883",
    x: 32,
    y: 32,
    width: 100,
    height: 130.938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 76.7524
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.4692
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.332833 0 0 0 0 0.359516 0 0 0 0 0.755961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2091_13883"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkSaved);
export default __webpack_public_path__ + "static/media/bookmark-saved.0a94b9250506994c930b03833284f29b.svg";
export { ForwardRef as ReactComponent };